module.exports = __webpack_public_path__ + "img/Flag_of_the_Pitcairn_Islands.9a4a6410.svg";